import BaseModelAPI from '../BaseModelAPI';

export default class IncomingDocumentType extends BaseModelAPI {
	static entity = 'incomingdocumenttype';
	static entityName = 'incomingdocumenttype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}